export default __webpack_public_path__ + "static/media/firstcry.4e769ebb.png";